module.exports = __webpack_public_path__ + "static/media/music.4a8b69e2.svg";